import { SxProps } from "@mui/material";

export const sxRating: SxProps = {
    '& .MuiRating-iconFilled': {
        color: '#00995D',
    },
}

export const sxQuestionTextField: SxProps = {
    '.MuiOutlinedInput-root': {
        height: 'fit-content'
    },
    fieldset : {
        display: 'flex',
        boxSizing: 'border-box'
    },
    textarea: {
        fontFamily: 'Unimed-Sans', 
        color: '#383838', 
        fontSize: '14px', 
    }
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px '
}